import { RESET_DOCUMENT_FORM } from '../actionTypes';
import { templateDocumentsActions } from '../reducer';

export default () => templateDocumentsActions[RESET_DOCUMENT_FORM]();
